import { PFlex, PHeadline, PText, PTextFieldWrapper, PIcon } from '@porsche-design-system/components-react'
import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'

import * as ModuleApi from '../../../utils/api/Modules'
import * as SubAppApi from '../../../utils/api/SubApps'

import { ApplicationContext } from '../../../utils/Context/ApplicationContext'
import AppIDField from '../../AppIDField/AppIDField'
import DrawerFooter from '../Footer/DrawerFooter'

import { TOAST_TIME } from '../../../config/config'
import { PortalContext } from '../../../utils/PortalContext'

import styles from './drawernewsubapp.module.css'

interface SubApplication {
  idApp: number
  appId: string
  subAppDescription: string
  department: string
  applicationManager: string
  businessResponsible: boolean
}

interface formData {
  appId?: string
  subAppDescription: string
  department?: string
  applicationManager?: string
  businessResponsible?: boolean
}

export default function DrawerNewSubApp() {
  const { setOpenDrawer, drawerData, setLoading, setToastContent, setToast, setError } = React.useContext(PortalContext)

  const { applications, setApplications } = React.useContext(ApplicationContext)

  const methods = useForm<SubApplication>({
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  })

  const closeDrawer = () => {
    setOpenDrawer(false)
  }

  const defaultValue = {
    subAppDescription: '',
    appId: ''
  }

  const endCreateSubAppProcess = () => {
    setToastContent('Der Unterbereich wurde erfolgreich angelegt!')
    setToast(true)
    methods.reset(defaultValue)
    setOpenDrawer(false)
    setTimeout(() => {
      setLoading(false)
      setToast(false)
    }, TOAST_TIME)
  }

  const addNewSubApplication = (data: formData) => {
    setLoading(true)
    if (drawerData.appInformation.type === 'app') {
      const newAppId = data.appId === '' ? drawerData.appInformation.appId : 'APP-' + data.appId
      const subApp = {
        idApp: drawerData.appInformation.id,
        appId: newAppId,
        subAppDescription: data.subAppDescription,
        department: drawerData.appInformation.department,
        members: drawerData.appInformation.members,
        businessResponsible: drawerData.appInformation.businessResponsible
      }
      SubAppApi.create(subApp)
        .then((response) => response.json())
        .then((newSubApp) => {
          const index = applications.findIndex((app) => app.app === drawerData.appInformation.id)
          if (applications[index].subApp) {
            applications[index].subApp.push(newSubApp)
          } else {
            applications[index] = {
              ...applications[index],
              subApp: [newSubApp]
            }
          }
          setApplications(applications)
          endCreateSubAppProcess()
        })
        .catch((err) => {
          setError(true)
          setToastContent(err.message)
          setToast(true)
        })
    } else {
      const newAppId = data.appId === '' ? drawerData.appInformation.appId : 'APP-' + data.appId
      const module = {
        idSubApp: drawerData.appInformation.id,
        idApp: drawerData.appInformation.parents.idApp,
        appId: newAppId,
        moduleDescription: data.subAppDescription,
        department: drawerData.appInformation.department,
        members: drawerData.appInformation.members,
        businessResponsible: drawerData.appInformation.businessResponsible
      }
      ModuleApi.create(module)
        .then((response) => response.json())
        .then((newModule) => {
          const appIndex = applications.findIndex((app) => app.app === drawerData.appInformation.parents.idApp)
          const index = applications[appIndex].subApp.findIndex(
            (subApp: { subAppId: number }) => subApp.subAppId === drawerData.appInformation.id
          )
          if (applications[appIndex].subApp[index].modules) {
            applications[appIndex].subApp[index].modules.push(newModule)
          } else {
            applications[appIndex].subApp[index] = {
              ...applications[appIndex].subApp[index],
              modules: [newModule]
            }
          }
          setApplications(applications)
          endCreateSubAppProcess()
        })
        .catch((err) => {
          setError(true)
          setToastContent(err.message)
          setToast(true)
        })
    }
  }

  React.useEffect(() => {
    methods.register('subAppDescription', {
      required: true
    })
  }, [methods])

  return (
    <FormProvider {...methods}>
      <form className={styles.form} onSubmit={methods.handleSubmit(addNewSubApplication)} noValidate>
        <PFlex wrap='wrap' direction='column' justifyContent='space-between' className={styles.container}>
          <main className={styles.content}>
            <PFlex justifyContent='space-between' className={styles.appInfo}>
              <PText>
                von <b>{drawerData.appInformation.title}</b>
              </PText>
              <PText align='right'>{drawerData.appInformation.icto}</PText>
            </PFlex>
            <PHeadline variant='headline-5'>Identifikation</PHeadline>
            <PTextFieldWrapper
              label='Bezeichnung'
              className={styles.textfield}
              state={methods.errors.subAppDescription ? 'error' : 'none'}
              message='Das Feld wird benötigt.'
            >
              <input type='text' required name='subAppDescription' placeholder='Name' ref={methods.register} />
            </PTextFieldWrapper>
            <AppIDField />
          </main>
          <DrawerFooter onClick={closeDrawer} />
        </PFlex>
      </form>
    </FormProvider>
  )
}
